module.exports = __webpack_public_path__ + "img/02logo-gkc2022.7ee7ee44.png";